import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const RegisterCoachPage = () => {
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [joinExisting, setJoinExisting] = useState('no'); // 'yes' | 'no'
  const [clubName, setClubName] = useState('');
  const [clubSecret, setClubSecret] = useState('');

  const [loading, setLoading] = useState(false);
  const [serverMsg, setServerMsg] = useState(null);

  const validate = () => {
    if (!name.trim() || !email.trim() || !password.trim()) {
      alert('Name, Email and Password are required.');
      return false;
    }
    if (joinExisting === 'yes') {
      if (!clubName.trim() || !clubSecret.trim()) {
        alert('Club Name and Club Secret are required to join an existing club.');
        return false;
      }
    } else {
      if (!clubName.trim()) {
        alert('Club Name is required to create a new club.');
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setServerMsg(null);

    try {
      const res = await fetch('https://vballbackend.onrender.com/api/coach/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email: email.toLowerCase(),
          password,
          joinExisting: joinExisting === 'yes',
          clubName,
          clubSecret: joinExisting === 'yes' ? clubSecret : undefined
        })
      });

      const data = await res.json();

      if (!res.ok) {
        setServerMsg(data.msg || 'Registration failed');
        setLoading(false);
        return;
      }

      // If the coach created a new club, we can optionally show the generated secret
      if (data.created_new_club && data.club_secret) {
        alert(
          `Coach registered successfully!\n\nYour club secret (share only with trusted coaches):\n${data.club_secret}`
        );
      } else {
        alert('Coach registered successfully!');
      }

      navigate('/');
    } catch (err) {
      console.error(err);
      setServerMsg('Server error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 520, marginTop: '4rem' }}>
      <div className="card">
        <h2 className="mb-4">Register a Coach Account</h2>

        <form onSubmit={handleSubmit} className="flex-col" style={{ gap: '0.75rem' }}>
          <label className="text-muted">Name</label>
          <input
            type="text"
            value={name}
            placeholder="Your name"
            onChange={(e) => setName(e.target.value)}
            required
          />

          <label className="text-muted">Email Address</label>
          <input
            type="email"
            value={email}
            placeholder="you@example.com"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="text-muted">Password</label>
          <input
          type="password"
          value={password}
          placeholder="Choose a password"
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <h3 className="mt-4 mb-2">Join Existing Club?</h3>
        <div className="flex-row" style={{ gap: '1rem', alignItems: 'center' }}>
          <label>
            <input
              type="radio"
              name="joinExisting"
              value="yes"
              checked={joinExisting === 'yes'}
              onChange={() => setJoinExisting('yes')}
            />{' '}
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="joinExisting"
              value="no"
              checked={joinExisting === 'no'}
              onChange={() => setJoinExisting('no')}
            />{' '}
            No
          </label>
        </div>

        {/* Conditional fields */}
        {joinExisting === 'yes' ? (
          <>
            <label className="text-muted mt-3">Club Name</label>
            <input
              type="text"
              value={clubName}
              placeholder="Enter the existing club name"
              onChange={(e) => setClubName(e.target.value)}
            />

            <label className="text-muted">Club Secret</label>
            <input
              type="text"
              value={clubSecret}
              placeholder="Enter the club secret you were given"
              onChange={(e) => setClubSecret(e.target.value)}
            />
          </>
        ) : (
          <>
            <label className="text-muted mt-3">Club Name</label>
            <input
              type="text"
              value={clubName}
              placeholder="Pick a name for your new club"
              onChange={(e) => setClubName(e.target.value)}
            />
          </>
        )}

        {serverMsg && (
          <div style={{ color: 'red', marginTop: '0.5rem' }}>{serverMsg}</div>
        )}

        <button
          type="submit"
          className="btn-primary mt-3"
          disabled={loading}
          style={{ opacity: loading ? 0.6 : 1 }}
        >
          {loading ? 'Registering...' : 'Register'}
        </button>
      </form>
    </div>
  </div>
  );
};

export default RegisterCoachPage;
